import { useEffect, useState } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (q) => `${q.price.toLocaleString("en-GB", { maximumFractionDigits: q.price < 10 ? 4 : 2 })}${q.unit ? ` ${q.unit}` : ""}`;

const Item = ({ q }) => {
  const c = q.chg_1w ?? 0;
  return (
    <span className="flex items-center gap-2 px-6 whitespace-nowrap">
      <span className="text-[#E7E7E7]/60">{q.name}</span>
      <span className="text-[#FFFFFF]">{fmt(q)}</span>
      <span className={`flex items-center gap-0.5 ${c >= 0 ? "text-[#7FBF8E]" : "text-[#E58A6B]"}`}>
        {c >= 0 ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
        {c > 0 ? "+" : ""}{c.toFixed(1)}% <span className="text-[#E7E7E7]/40">1W</span>
      </span>
    </span>
  );
};

export const Ticker = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/markets").then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  return (
    <div data-testid="commodity-ticker" className="ticker-wrap bg-[#0A0A0A] overflow-hidden font-mono-d text-[11px] py-2 flex items-center min-h-[33px]">
      <span className="shrink-0 px-4 overline text-[#E5332A] border-r border-white/10 z-10 bg-[#0A0A0A]" title="Delayed futures and FX quotes via Yahoo Finance">Markets</span>
      {items.length > 0 && <div className="ticker-track">{[...items, ...items].map((q, i) => <Item key={i} q={q} />)}</div>}
    </div>
  );
};
